import React from 'react';
import { Grid } from '@mui/material';
import TestCycleInactiveCard from './TestCycleInactiveCard';

const TestCycleHealthSection = () => (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item xs={12} md={12}>
      <TestCycleInactiveCard sx={{ height: '100%' }} />
    </Grid>
  </Grid>
);

export default TestCycleHealthSection;